import { Updatable } from './updatable';
export const REQUEST_FAILED = 'REQUEST_FAILED';
export const CLEAR_FAILURE = 'CLEAR_FAILURE';

export interface FailedPayload {
    id?: number | string;
    type: string;
    error?: string;
}

export interface FailedUpdatePayload extends FailedPayload {
    type: Updatable;
}

interface FailedAction {
    type: typeof REQUEST_FAILED;
    payload: FailedPayload;
}

interface ClearFailureAction {
    type: typeof CLEAR_FAILURE;
    payload: FailedPayload;
}

export type FailedActionType = FailedAction | ClearFailureAction;

// Action Creators

export const requestFailedAction: (name: string, error: string, id?: number | string) => FailedAction = (
    name,
    error,
    id = null,
) => {
    return {
        type: REQUEST_FAILED,
        payload: {
            type: name,
            error,
            id,
        },
    };
};

export const clearFailure: (type: string, id?: number | string) => ClearFailureAction = (type, id = null) => {
    return {
        type: CLEAR_FAILURE,
        payload: {
            type,
            id,
        },
    };
};
